// Builds the /simulate request body. Lives outside App.js so it can be tested
// without driving the canvas.

// A usability gate, not a model limit — the simulation accepts any value. The
// Assumptions tab documents the same threshold.
export const NOT_VIABLE_DEPRESSURIZATION_PA = 2.5;

function toNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

// A depressurized room always opposes draft, so the sign carries no meaning. The
// backend applies abs() as well.
export function depressurizationMagnitude(value) {
  return Math.abs(toNumber(value, 0));
}

// Exclusive: 2.5 Pa is viable.
export function isDesignNotViable(depressurizationPa) {
  return depressurizationMagnitude(depressurizationPa) > NOT_VIABLE_DEPRESSURIZATION_PA;
}

// parts and elbows are passed through untouched; fireProfiles must include `balanced`.
export function buildSimulationPayload({
  parts,
  elbows,
  elevationFt,
  depressurizationPa,
  selectedFireProfile,
  customProfile,
  fireProfiles,
}) {
  const profile = fireProfiles[selectedFireProfile] || fireProfiles.balanced;
  const useCustomCurve = selectedFireProfile === 'custom' && customProfile;

  return {
    parts,
    elbows,
    dt: 0.5,
    total_time: 600,
    elevation_ft: toNumber(elevationFt, 0),
    room_depressurization_pa: depressurizationMagnitude(depressurizationPa),
    inlet_restriction: {
      enable: true,
      door_type: 'swivel',
      door_width_ft: 1.2708,
      door_height_ft: 0.8229,
      Cd: 0.62,
      A_leak_m2: 0.0075,
      inlet_area_min_m2: 0.003,
      K_stove: 0,
    },
    // Door schedule is always a preset; only the inlet-temp curve can be custom.
    door_schedule: profile.doorSchedule || fireProfiles.balanced.doorSchedule,
    inlet_temp_profile: useCustomCurve
      ? customProfile.points
      : (profile.inletTempProfile || fireProfiles.balanced.inletTempProfile),
    verbose: false,
  };
}
